import type { MiddlewareAPI } from 'redux';
import 'rxjs/add/operator/map';
import type { ActionsObservable } from 'redux-observable';
import type { Action } from '../../state/actions';
import { saveProjectDetails } from '../../state/entities/actions';
import type { AppState } from '../../state/types';
import {
	SAVE_BUTTON_CLICKED,
	type SaveButtonClickedAction,
	fieldValidationForced,
} from '../../state/ui/actions';
import { validationErrorsSelector } from '../../state/ui/selectors';
import { type ValidationErrors, MESSAGE_TYPE_ERROR } from '../../state/ui/types';

const validateErrorsIgnoreWarnings = (errors: ValidationErrors) => {
	if (errors.projectName?.type === MESSAGE_TYPE_ERROR) {
		return fieldValidationForced('projectName');
	}
	if (errors.projectKey?.type === MESSAGE_TYPE_ERROR) {
		return fieldValidationForced('projectKey');
	}
	if (errors.projectUrl?.type === MESSAGE_TYPE_ERROR) {
		return fieldValidationForced('projectUrl');
	}
	if (errors.projectTeamTypeFreeText?.type === MESSAGE_TYPE_ERROR) {
		return fieldValidationForced('projectTeamTypeFreeText');
	}
	return undefined;
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (action$: ActionsObservable<Action>, store: MiddlewareAPI<AppState>) =>
	action$.ofType(SAVE_BUTTON_CLICKED).map(({ meta }: SaveButtonClickedAction) => {
		const state = store.getState();
		const errors = validationErrorsSelector(state);

		const validationResult = validateErrorsIgnoreWarnings(errors);

		return validationResult ?? saveProjectDetails(meta.analyticsEvent);
	});
